import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { ProductService } from './product.service';
import { Product } from "../classes/product";
import { LoginService } from 'src/app/mylogin/loginc/login.service';
import { firstValueFrom, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  products: Product[] = [];
  PIproducts: any[] = [];
  amount: number = 0;
  constructor(
    public router: Router,
    public productService: ProductService,
    public Loginservice: LoginService
  ) {

    this.productService.cartItems.subscribe((response) => {


      this.products = response;


    });
  }



  // logout() {

  //   if (this.products.length > 0) {
  //     if (confirm("Would you like to add the items in your cart to your wishlist for a future order?") == false) {
  //       const setting = localStorage.getItem('setting');
  //       localStorage.clear();
  //       localStorage.removeItem('isLoggedIn');
  //       localStorage.removeItem('user');
  //       localStorage.removeItem('products')
  //       localStorage.removeItem('cartItems')
  //       localStorage.removeItem('customercredit')
  //       localStorage.removeItem('customerbalance')
  //       localStorage.removeItem('customername')
  //       localStorage.removeItem('country')
  //       localStorage.removeItem('promotiondata')

  //       if (setting != null) {
  //         localStorage.setItem('setting', setting);
  //       }

  //       // this.router.navigate(['/company']);
  //       //.location.reload();
  //       this.router.navigate(['/company']).then(() => {
  //         window.location.reload();
  //       });


  //     }

  //     else {






  //           const itemList = this.products.map(product => ({
  //             itemName: product.title,
  //             itemNumber: product.id,
  //             quantity: product.quantity
  //           }));



  //           let data = {
  //             customer_Id: localStorage['customer_Id'],
  //             customerNumber: localStorage['customerNumber'],
  //             itemList : itemList
  //           }


  //           this.Loginservice.addtowishlistonlogout(data).subscribe((res:any)=>{



  //             const setting = localStorage.getItem('setting');
  //     localStorage.clear();
  //     localStorage.removeItem('isLoggedIn');
  //     localStorage.removeItem('user');
  //     localStorage.removeItem('products')
  //     localStorage.removeItem('cartItems')
  //     localStorage.removeItem('customercredit')
  //     localStorage.removeItem('customerbalance')
  //     localStorage.removeItem('customername')
  //     localStorage.removeItem('country')
  //     localStorage.removeItem('promotiondata')

  //     if (setting != null) {
  //       localStorage.setItem('setting', setting);
  //     }

  //     // this.router.navigate(['/company']);
  //     //.location.reload();
  //     this.router.navigate(['/company']).then(() => {
  //       window.location.reload();
  //     });



  //           })

  //     }

  //   }
  //   else {

  //     const setting = localStorage.getItem('setting');
  //     localStorage.clear();
  //     localStorage.removeItem('isLoggedIn');
  //     localStorage.removeItem('user');
  //     localStorage.removeItem('products')
  //     localStorage.removeItem('cartItems')
  //     localStorage.removeItem('customercredit')
  //     localStorage.removeItem('customerbalance')
  //     localStorage.removeItem('customername')
  //     localStorage.removeItem('country')
  //     localStorage.removeItem('promotiondata')

  //     if (setting != null) {
  //       localStorage.setItem('setting', setting);
  //     }

  //     // this.router.navigate(['/company']);
  //     //.location.reload();
  //     this.router.navigate(['/company']).then(() => {
  //       window.location.reload();
  //     });

  //   }

  // }
  public get getTotal(): Observable<number> {
        return this.productService.cartTotalAmount();
      }

  async logout() {
    this.getTotal.subscribe(amount => this.amount = amount);
    if (this.products.length > 0) {
      const editMode = localStorage.getItem('editMode') === 'true';
      const cartItems = await firstValueFrom(this.productService.cartItems);
      const hasCartItems = cartItems && cartItems.length > 0;

      console.log("hasCartItems:", hasCartItems);

      // Step 0: Check if user is in non-edit mode and cart has items
      if (!editMode && hasCartItems) {

        const userConfirmed = confirm(
          "You already have items in your cart. Do you want to save them as a draft order?"
        );

        if (!userConfirmed) {
          // User canceled saving existing cart as draft

          console.log("User canceled saving existing cart as draft.");
          const setting = localStorage.getItem('setting');
          localStorage.clear();
          localStorage.removeItem('isLoggedIn');
          localStorage.removeItem('user');
          localStorage.removeItem('products')
          localStorage.removeItem('cartItems')
          localStorage.removeItem('customercredit')
          localStorage.removeItem('customerbalance')
          localStorage.removeItem('customername')
          localStorage.removeItem('country')
          localStorage.removeItem('promotiondata')


          if (setting != null) {
            localStorage.setItem('setting', setting);
          }

          // this.router.navigate(['/company']);
          //.location.reload();
          this.router.navigate(['/company']).then(() => {
            window.location.reload();
          });
          // Step 1: Clear existing cart and add new order


        }

        this.adddraftorder();
        console.log("User wants to save existing cart as draft.");
      }
      else if (editMode && hasCartItems) {


        console.log("Edit mode is true and cart has items, clearing cart.");

        const userConfirmed = confirm(
          "You already have a waiting approval order in your cart. Do you want to save the changes?"
        );

        if (!userConfirmed) {
          // User canceled discarding the current order
          console.log("User canceled discarding the existing cart.");
          const setting = localStorage.getItem('setting');
          localStorage.clear();
          localStorage.removeItem('isLoggedIn');
          localStorage.removeItem('user');
          localStorage.removeItem('products')
          localStorage.removeItem('cartItems')
          localStorage.removeItem('customercredit')
          localStorage.removeItem('customerbalance')
          localStorage.removeItem('customername')
          localStorage.removeItem('country')
          localStorage.removeItem('promotiondata')

          if (setting != null) {
            localStorage.setItem('setting', setting);
          }

          // this.router.navigate(['/company']);
          //.location.reload();
          this.router.navigate(['/company']).then(() => {
            window.location.reload();
          });
        }

        this.editwfaorder();
      }
      else {

        const setting = localStorage.getItem('setting');
        localStorage.clear();
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('user');
        localStorage.removeItem('products')
        localStorage.removeItem('cartItems')
        localStorage.removeItem('customercredit')
        localStorage.removeItem('customerbalance')
        localStorage.removeItem('customername')
        localStorage.removeItem('country')
        localStorage.removeItem('promotiondata')

        if (setting != null) {
          localStorage.setItem('setting', setting);
        }

        // this.router.navigate(['/company']);
        //.location.reload();
        this.router.navigate(['/company']).then(() => {
          window.location.reload();
        });

      }



    }
    else {

      const setting = localStorage.getItem('setting');
      localStorage.clear();
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('user');
      localStorage.removeItem('products')
      localStorage.removeItem('cartItems')
      localStorage.removeItem('customercredit')
      localStorage.removeItem('customerbalance')
      localStorage.removeItem('customername')
      localStorage.removeItem('country')
      localStorage.removeItem('promotiondata')

      if (setting != null) {
        localStorage.setItem('setting', setting);
      }

      // this.router.navigate(['/company']);
      //.location.reload();
      this.router.navigate(['/company']).then(() => {
        window.location.reload();
      });

    }
  }

  editwfaorder() {

    const itemsString = localStorage.getItem('cartItems');

    const promotiondiscountvalue = localStorage.getItem('promotiondiscountvalue');
    this.discountval = Number(promotiondiscountvalue);

    console.log("Promotion Discount Value is " + promotiondiscountvalue);

    if (promotiondiscountvalue == null) {
      this.discountval = 0;
    }

    if (itemsString) {
      const items = JSON.parse(itemsString);

      console.log("🚀 > CheckoutComponent > items:", items)



      const orderLineItems = items.map((item: any) => {
        return {
          lineType: "Item",  // Replace with the actual product ID
          lineObjectNumber: item.id,  // Replace with the actual product name
          itemDescription: item.title,
          quantity: item.quantity,  // Replace with the actual .quantity
          unitPrice: item.price,  // Replace with the actual unit price
          taxCode: 'NON',  // Replace with the actual unit of measure
          discountPercent: item.discount,
          discountAmount: 0,
          netAmount: (item.price || 0) * (item.quantity || 0) * (1 - ((item.discount || 0) / 100))
        };
      });
      if (this.PIproducts.length > 0) {
        const PIitems = this.PIproducts.map((item: any) => {
          return {
            lineType: "Item",
            lineObjectNumber: item.id,
            itemDescription: item.title,
            quantity: item.quantity,
            unitPrice: item.price,
            taxCode: 'NON',
            discountPercent: 100,
            discountAmount: 0,
            isFOCItem: true,
            netAmount: 0
          };
        });
        orderLineItems.push(...PIitems);
      }


      var createdBy = 'CUSTOMER';
      var createdByCode = '';
      const SaleRapDataString = localStorage.getItem('SalesRepData') as string;

      console.log("🚀 > CheckoutComponent > SaleRapDataString:", SaleRapDataString)
      if (SaleRapDataString != "undefined" && SaleRapDataString != null) {
        const SaleRapData = JSON.parse(SaleRapDataString);

        console.log("🚀 > CheckoutComponent > SaleRapData:", SaleRapData)
        createdBy = 'SALESPERSON';
        createdByCode = SaleRapData.code;

        console.log("🚀 > CheckoutComponent > SaleRapData.code:", SaleRapData.code)
      } else {
        createdBy = 'CUSTOMER';
        createdByCode = localStorage.getItem('customerNumber');

        console.log("🚀 > CheckoutComponent > localStorage.getItem('customerNumber'):", localStorage.getItem('customerNumber'))
      }

      // Conditionally construct workdescription based on true/false values
      let workDescription = '123';


      const orderid = localStorage.getItem('editOrderId') || '';

      const orderData = {

        salesOrderId: orderid,
        countryList_Id: localStorage.getItem('country'),
        postingDate: new Date().toISOString(),
        customerNumber: localStorage.getItem('customerNumber'),
        externalDocumentNumber: '',
        documentType: "Order",
        requestedDeliveryDate: null,
        shipToCode: '123',
 customerName:localStorage.getItem('cname') || localStorage.getItem('selectedCustomerName'),
        workdescription: workDescription,

        createdBy: createdBy,
        createdByCode: createdByCode,
        invoiceDiscount: this.discountval,
        orderStatus: "processing",
        totalAmountIncludingTax: Number(localStorage.getItem("totalafterdiscount")) || this.amount,
        lines: orderLineItems,




      }

      console.log("==============WFA Order Data Start=============");
      console.log(orderData);
      console.log("==============WFA Data End=============");


      this.Loginservice.editwfaOrder(orderData).subscribe((response: any) => {
        console.log("🚀 > CheckoutComponent > editwfaOrder response:", response);
        if (response.apiStatus.isSuccess) {
          console.log("wfa order saved successfully:", response);

          const setting = localStorage.getItem('setting');
          localStorage.clear();
          localStorage.removeItem('isLoggedIn');
          localStorage.removeItem('user');
          localStorage.removeItem('products')
          localStorage.removeItem('cartItems')
          localStorage.removeItem('customercredit')
          localStorage.removeItem('customerbalance')
          localStorage.removeItem('customername')
          localStorage.removeItem('country')
          localStorage.removeItem('promotiondata')

          if (setting != null) {
            localStorage.setItem('setting', setting);
          }

          // this.router.navigate(['/company']);
          //.location.reload();
          this.router.navigate(['/company']).then(() => {
            window.location.reload();
          });

        }
      },
        (error) => {
          console.error("Error saving draft order:", error);

        }
      );


    }



  }

  discountval: number
  adddraftorder() {
    const itemsString = localStorage.getItem('cartItems');

    const promotiondiscountvalue = localStorage.getItem('promotiondiscountvalue');
    this.discountval = Number(promotiondiscountvalue);

    console.log("Promotion Discount Value is " + promotiondiscountvalue);

    if (promotiondiscountvalue == null) {
      this.discountval = 0;
    }

    if (itemsString) {
      const items = JSON.parse(itemsString);

      console.log("🚀 > CheckoutComponent > items:", items)



      const orderLineItems = items.map((item: any) => {
        return {
          lineType: "Item",  // Replace with the actual product ID
          lineObjectNumber: item.id,  // Replace with the actual product name
          itemDescription: item.title,
          quantity: item.quantity,  // Replace with the actual .quantity
          unitPrice: item.price,  // Replace with the actual unit price
          taxCode: 'NON',  // Replace with the actual unit of measure
          discountPercent: item.discount,
          discountAmount: 0,
          netAmount: (item.price || 0) * (item.quantity || 0) * (1 - ((item.discount || 0) / 100))
        };
      });
      if (this.PIproducts.length > 0) {
        const PIitems = this.PIproducts.map((item: any) => {
          return {
            lineType: "Item",
            lineObjectNumber: item.id,
            itemDescription: item.title,
            quantity: item.quantity,
            unitPrice: item.price,
            taxCode: 'NON',
            discountPercent: 100,
            discountAmount: 0,
            isFOCItem: true,
            netAmount: 0
          };
        });
        orderLineItems.push(...PIitems);
      }


      var createdBy = 'CUSTOMER';
      var createdByCode = '';
      const SaleRapDataString = localStorage.getItem('SalesRepData') as string;

      console.log("🚀 > CheckoutComponent > SaleRapDataString:", SaleRapDataString)
      if (SaleRapDataString != "undefined" && SaleRapDataString != null) {
        const SaleRapData = JSON.parse(SaleRapDataString);

        console.log("🚀 > CheckoutComponent > SaleRapData:", SaleRapData)
        createdBy = 'SALESPERSON';
        createdByCode = SaleRapData.code;

        console.log("🚀 > CheckoutComponent > SaleRapData.code:", SaleRapData.code)
      } else {
        createdBy = 'CUSTOMER';
        createdByCode = localStorage.getItem('customerNumber');

        console.log("🚀 > CheckoutComponent > localStorage.getItem('customerNumber'):", localStorage.getItem('customerNumber'))
      }

      // Conditionally construct workdescription based on true/false values
      let workDescription = '123';


      const ordeid = localStorage.getItem('editOrderId') || '';


      const orderData: any = {



        countryList_Id: localStorage.getItem('country'),
        postingDate: new Date().toISOString(),
        customerNumber: localStorage.getItem('customerNumber'),
        externalDocumentNumber: '',
        documentType: "Order",
        requestedDeliveryDate: null,
        shipToCode: '123',
 customerName:localStorage.getItem('cname') || localStorage.getItem('selectedCustomerName'),
        workdescription: workDescription,

        createdBy: createdBy,
        createdByCode: createdByCode,
        invoiceDiscount: this.discountval,
        orderStatus: "draft",
        totalAmountIncludingTax: Number(localStorage.getItem("totalafterdiscount")) || this.amount,
        lines: orderLineItems,
        // Optionally initialize salesOrderId as undefined
        salesOrderId: undefined
      }

      console.log("==============Dreaft Order Data Start=============");
      console.log(orderData);
      console.log("==============Order Data End=============");


      if (ordeid == '' || ordeid == null || ordeid == '0') {

        this.Loginservice.makeorderdb(orderData).subscribe((response: any) => {
          if (response.apiStatus.isSuccess) {
            console.log("Draft order saved successfully:", response);

            const setting = localStorage.getItem('setting');
            localStorage.clear();
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('user');
            localStorage.removeItem('products')
            localStorage.removeItem('cartItems')
            localStorage.removeItem('customercredit')
            localStorage.removeItem('customerbalance')
            localStorage.removeItem('customername')
            localStorage.removeItem('country')
            localStorage.removeItem('promotiondata')

            if (setting != null) {
              localStorage.setItem('setting', setting);
            }

            // this.router.navigate(['/company']);
            //.location.reload();
            this.router.navigate(['/company']).then(() => {
              window.location.reload();
            });


          } else {

          }
        },
          (error) => {
            console.error("Error saving draft order:", error);

          }
        );
      }
      else {

        orderData.salesOrderId = ordeid;
        this.Loginservice.editwfaOrder(orderData).subscribe((response: any) => {
          if (response.apiStatus.isSuccess) {
            console.log("Draft order edit successfully:", response);
            const setting = localStorage.getItem('setting');
            localStorage.clear();
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('user');
            localStorage.removeItem('products')
            localStorage.removeItem('cartItems')
            localStorage.removeItem('customercredit')
            localStorage.removeItem('customerbalance')
            localStorage.removeItem('customername')
            localStorage.removeItem('country')
            localStorage.removeItem('promotiondata')

            if (setting != null) {
              localStorage.setItem('setting', setting);
            }

            // this.router.navigate(['/company']);
            //.location.reload();
            this.router.navigate(['/company']).then(() => {
              window.location.reload();
            });

          } else {

          }
        },
          (error) => {
            console.error("Error saving draft order:", error);

          }
        );

      }

    }


  }

}
